import React, { useState,
  useEffect,
   useContext } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box, Checkbox, Grid, Paper
} from "@mui/material";
import { ThemeContext } from "../../../../../../../context/ThemeContextProvider";
import { useOrder } from "../../../../../../../context/OrderCreator/TablesContext/OrderContext";

const DivideOrderModal = ({ open, onClose, orderId, items, onSuccess }) => {
  const { mode } = useContext(ThemeContext);
const { divideOrder } = useOrder();
useEffect(() => {
  if (items && Array.isArray(items)) {
    setSubItems(items.map((item) => ({
      ...item,
      selected: false,
      quantity: 1,
    })));
  }
}, [items]);

  const [subItems, setSubItems] = useState(
    items.map((item) => ({ ...item, selected: false, quantity: 1 }))
  );

  const handleQuantityChange = (itemId, value) => {
    setSubItems((prev) =>
      prev.map((item) =>
        item.id === itemId ? { ...item, quantity: value } : item
      )
    );
  };

  const handleSelect = (itemId) => {
    setSubItems((prev) =>
      prev.map((item) =>
        item.id === itemId ? { ...item, selected: !item.selected } : item
      )
    );
  };

 const handleSubmit = async () => {
  const selectedItems = subItems
    .filter((item) => item.selected && item.quantity > 0)
    .map((item) => ({
      item_id: item.id,
      quantity: parseInt(item.quantity),
    }));

  if (selectedItems.length === 0) {
    alert("❗ اختر على الأقل صنف واحد.");
    return;
  }

  try {
    await divideOrder(orderId, selectedItems);

    alert("✅ تم تقسيم الطلب بنجاح");

    if (typeof window.refreshOrderDetails === "function") {
      window.refreshOrderDetails(orderId);
    }

    onClose();
    onSuccess?.();
  } catch (err) {
    alert(err.message || "❌ حدث خطأ أثناء تنفيذ الطلب.");
  }
};


  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: mode === "dark" ? "#232334" : "#fff",
          color: mode === "dark" ? "#fff" : "#232334",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: 22,
          textAlign: "center",
          color: "#EA7C69",
          bgcolor: mode === "dark" ? "#181824" : "#fff",
        }}
      >
        🧩 تقسيم الطلب
      </DialogTitle>
      <DialogContent
        sx={{ bgcolor: mode === "dark" ? "#232334" : "#fff" }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleSubmit();
          }
        }}
        tabIndex={0}
      >
        <Box sx={{ mt: 1 }}>
          <Grid container spacing={2}>
            {subItems.map((item) => (
              <Grid item xs={12} sm={6} key={item.id}>
                <Paper
                  elevation={item.selected ? 6 : 1}
                  sx={{
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    border: item.selected
                      ? "2px solid #EA7C69"
                      : mode === "dark"
                        ? "1px solid #444"
                        : "1px solid #eee",
                    borderRadius: 2,
                    background: item.selected
                      ? mode === "dark"
                        ? "#2c2230"
                        : "#fff7f3"
                      : mode === "dark"
                        ? "#232334"
                        : "#fafafa",
                    transition: "all 0.2s",
                  }}
                >
                  <Checkbox
                    checked={item.selected}
                    onChange={() => handleSelect(item.id)}
                    sx={{
                      color: "#EA7C69",
                      "&.Mui-checked": { color: "#EA7C69" },
                    }}
                  />
                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontWeight: 600, color: mode === "dark" ? "#fff" : "#232334" }}>
                      {item.product_name}
                    </Typography>
                    <Typography sx={{ fontSize: 13, color: mode === "dark" ? "#aaa" : "#888" }}>
                      المتاح: {item.available_quantity ?? item.quantity}
                    </Typography>
                  </Box>
                  <TextField
                    type="number"
                    size="small"
                    label="الكمية"
                    value={item.quantity}
                    onChange={(e) =>
                      handleQuantityChange(item.id, e.target.value)
                    }
                    disabled={!item.selected}
                    inputProps={{ min: 1, style: { width: 60, textAlign: "center" } }}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: 2,
                        bgcolor: mode === "dark" ? "#181824" : "#fff",
                        color: mode === "dark" ? "#fff" : "#232334",
                      },
                      "& .MuiInputLabel-root": {
                        color: mode === "dark" ? "#aaa" : undefined,
                      },
                    }}
                  />
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2, bgcolor: mode === "dark" ? "#232334" : "#fff" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="secondary"
          sx={{
            minWidth: 100,
            borderColor: mode === "dark" ? "#888" : undefined,
            color: mode === "dark" ? "#fff" : undefined,
          }}
        >
          إلغاء
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            bgcolor: "#EA7C69",
            color: "#fff",
            minWidth: 120,
            fontWeight: 700,
            "&:hover": { bgcolor: "#d45d4c" },
          }}
        >
          تنفيذ
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DivideOrderModal;